import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';

import AuthContext from 'providers/auth';

const JobPlayButton = ({ botId, className, enabled }) => {
  const { t } = useTranslation();
  const currentUserContext = useContext(AuthContext);
  const { is_holder: currentUserIsHolder } = currentUserContext.me;

  const disabled = !enabled && !currentUserIsHolder;

  const title = disabled ? t('bots.jobs.disabled') : '';

  return (
    <div title={title}>
      <Link to={`/bots/${botId}/jobs/add`} type="button" className={className || `btn btn-outline-light btn-lg ${disabled ? 'disabled' : ''}`}>
        {t('actions.run')}
      </Link>
    </div>
  );
};

export default JobPlayButton;
